import React from 'react';
import styled from 'styled-components';
import { fadeIn, slideUp } from '../styles/animations';

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.3s ease;
  z-index: 1000;
`;

const DialogBox = styled.div`
  background-color: ${({ theme }) => theme.body || 'white'};
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 25px rgba(0,0,0,0.3);
  animation: ${slideUp} 0.4s ease-out;
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily || 'inherit'};
  border: 2px solid ${({ theme }) => theme.controlsBorder || 'rgba(255,255,255,0.2)'};
`;

const Message = styled.p`
  font-size: 18px;
  color: ${({ theme }) => theme.text || '#333'};
  margin-bottom: 25px;
  font-family: ${({ theme }) => theme.fontFamily || 'inherit'};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
`;

const Button = styled.button`
  padding: 12px 25px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
  font-family: ${({ theme }) => theme.fontFamily || 'inherit'};

  &.confirm {
    background-color: ${({ theme }) => theme.buttonColor || '#28a745'};
    color: white;
    &:hover {
      opacity: 0.9;
      transform: scale(1.05);
    }
  }

  &.cancel {
    background-color: ${({ theme }) => theme.controlsBorder || '#dc3545'};
    color: white;
    &:hover {
      opacity: 0.9;
      transform: scale(1.05);
    }
  }
`;

const ConfirmDialog = ({ message, onConfirm, onCancel, confirmText = 'Confirm', cancelText = 'Cancel', showCancel = true, theme }) => {
  return (
    <DialogOverlay>
      <DialogBox theme={theme}>
        <Message theme={theme}>{message}</Message>
        <ButtonContainer>
          <Button className="confirm" theme={theme} onClick={onConfirm}>{confirmText}</Button>
          {showCancel && <Button className="cancel" theme={theme} onClick={onCancel}>{cancelText}</Button>}
        </ButtonContainer>
      </DialogBox>
    </DialogOverlay>
  );
};

export default ConfirmDialog; 